export default {
  //物流接口
  getLogisticsOrderList: '/api/logisticsOrder/getLogisticsOrderList', //获取物流订单列表
  addLogisticsOrder: '/api/logisticsOrder/addLogisticsOrder', //添加物流订单
  editLogisticsOrder: '/api/logisticsOrder/editLogisticsOrder', //修改物流订单
  delLogisticsOrder: '/api/logisticsOrder/delLogisticsOrder', //删除物流订单
  getProjectPrincipalList: '/api/projectPrincipal/getProjectPrincipalList', //获取项目负责人列表不分页
};
